import {
    TASKS_DRAFTS_LIST_LOADING,
    TASKS_DRAFTS_LIST,
    TASKS_GET_OPTIONS,
} from '../../actions';

import { TASK_OPTIONS } from '../../../DTOs/taskOptions';

const INITIAL_STATE = {
    content: [],
    totalElements: 0,
    totalPages: 0,
    size: 20,
    number: 0,
    loading: false,
    listTaskOptions: { ...TASK_OPTIONS },
};

const draftTasks = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TASKS_DRAFTS_LIST_LOADING:
            return { ...state, loading: true };
        case TASKS_DRAFTS_LIST:
            return {
                ...state,
                ...action.list,
                loading: false,
            };
        case TASKS_GET_OPTIONS:
            return { ...state, listTaskOptions: action.initOptions };
        default:
            return state;
    }
};
export default draftTasks;
